<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <div v-if="activeTab === 'All'">
      <b-form-group label="Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.code"
          v-model="statusFilterValue"
          :value="option.code"
          name="coupon-status-filter"
        >
          {{ option.title }}
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-form-group label="Value Type">
      <b-form-checkbox
        v-for="option in valueTypeOptions"
        :key="option.code"
        v-model="valueTypeFilterValue"
        :value="option.code"
        name="coupon-value-type-filter"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
  },
  props: {
    activeTab: {
      type: String,
      default: 'All',
    },
    valueType: {
      type: [Array, null],
      default: null,
    },
    valueTypeOptions: {
      type: Array,
      required: true,
    },
    status: {
      type: [Array, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      valueTypeFilterValue: JSON.parse(JSON.stringify(this.valueType)) || [],
      statusFilterValue: JSON.parse(JSON.stringify(this.status)) || [],
    }
  },
  watch: {
    valueType: {
      immediate: true,
      handler(val) {
        this.valueTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    status: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:value-type', this.valueTypeFilterValue)
      this.$emit('update:status', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.valueTypeFilterValue = []
      this.statusFilterValue = []

      this.$emit('update:value-type', this.valueTypeFilterValue)
      this.$emit('update:status', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>
